@if (isInteractive()) {
  <m-nav-trigger
    [open]="isOpen()"
    [disabled]="disabled()"
    [ariaLabel]="ariaLabel() || label()"
    [ariaHaspopup]="true"
    [ariaExpanded]="isOpen()"
    (clicked)="togglePanel($event)">
    <span class="brand-picker-label sh2 truncate">{{ label() }}</span>
    <em aria-hidden="true" class="material-symbols-outlined icon-small chevron"
      >expand_all</em
    >
  </m-nav-trigger>

  <p-popover
    #popover
    mHideOnWindowScroll
    styleClass="brand-picker-panel"
    appendTo="body"
    [dismissable]="true"
    (onShow)="onShow()"
    (onHide)="onHide()">
    <div class="brand-picker-content">
      <m-input-search
        #searchInput
        placeholder="Search"
        [ngModel]="searchQuery()"
        (ngModelChange)="onSearchInput($event)"
        (keydown)="onSearchKeydown($event)">
      </m-input-search>
      <div #brandList class="brand-picker-list">
        @if (showRecents()) {
          @for (
            brand of recentBrands();
            track brand.clientId + "-" + brand.brandId
          ) {
            <ng-container
              *ngTemplateOutlet="
                brandItem;
                context: { $implicit: brand, index: $index }
              "></ng-container>
          }
          <p-divider class="my-1"></p-divider>
          @for (brand of rest(); track brand.clientId + "-" + brand.brandId) {
            <ng-container
              *ngTemplateOutlet="
                brandItem;
                context: { $implicit: brand, index: $index + recentBrands().length }
              "></ng-container>
          }
        } @else if (filteredBrands().length === 0) {
          <div class="brand-picker-empty b2">No brands found</div>
        } @else {
          @for (
            brand of filteredBrands();
            track brand.clientId + "-" + brand.brandId
          ) {
            <ng-container
              *ngTemplateOutlet="
                brandItem;
                context: { $implicit: brand, index: $index }
              "></ng-container>
          }
        }
      </div>
    </div>
  </p-popover>
} @else {
  <span class="brand-picker-label sh2 truncate">{{ label() }}</span>
}

<ng-template #brandItem let-brand let-index="index">
  @if (brand.url) {
    <a
      class="brand-picker-item"
      [class.brand-picker-item-active]="activeBrandIndex() === index"
      [href]="brand.url"
      (click)="onBrandClick(brand, $event)">
      <ng-container
        *ngTemplateOutlet="
          brandItemContent;
          context: { $implicit: brand }
        "></ng-container>
    </a>
  } @else {
    <button
      type="button"
      class="brand-picker-item"
      [class.brand-picker-item-active]="activeBrandIndex() === index"
      (click)="onBrandClick(brand, $event)">
      <ng-container
        *ngTemplateOutlet="
          brandItemContent;
          context: { $implicit: brand }
        "></ng-container>
    </button>
  }
</ng-template>

<ng-template #brandItemContent let-brand>
  <span class="brand-picker-item-name b2" [attr.title]="brand.name">{{
    brand.name
  }}</span>
  <span class="brand-picker-item-meta c1"
    >Client ID: {{ brand.clientId }} • Brand ID: {{ brand.brandId }}</span
  >
</ng-template>
